<footer hide-sm="" class="footer">
  <span class="footer-brand">
    <img src="assets/images/icon/FocalPoint-Icon-1.png" alt="FocalPoint" class="footer-logo" />
    <span>Powered by <strong>FocalPoint</strong></span>
  </span>
</footer>
